import {
    temAcesso
} from '@/shared/auth/temAcesso'

const Usuarios = () => import('./../../ctrlacesso/usuarios/Usuarios.vue')
const UsuarioForm = () => import('./../../ctrlacesso/usuarios/FornecedorUsuarioForm.vue')
const UsuarioDetalhar = () => import('./../../ctrlacesso/usuarios/UsuarioDetalhar.vue')

export default {
    path: 'usuarios',
    name: 'Fornecedores_Usuarios',
    component: Usuarios,
    beforeEnter: (to, from, next) => {
        if (temAcesso('FORN-USR-00')) {
            next()
        }
    },
    children: [{
            path: 'inserir',
            name: 'Fornecedores_Usuarios_Inserir',
            component: UsuarioForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('FORN-USR-01')) {
                    next()
                }
            }
        },
        {
            path: ':usuarioId',
            name: 'Fornecedores_Usuarios_Detalhar',
            component: UsuarioDetalhar,
            beforeEnter: (to, from, next) => {
                if (temAcesso('FORN-USR-02')) {
                    next()
                }
            }
        },
        {
            path: ':usuarioId/atualizar',
            name: 'Fornecedores_Usuarios_Atualizar',
            component: UsuarioForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('FORN-USR-03')) {
                    next()
                }
            }
        }
        // ,
        // {
        //     path: 'perfisacesso/:usuarioId',
        //     name: 'Usuarios_PerfisAcesso',
        //     component: UsuarioPerfisAcesso,
        //     beforeEnter: (to, from, next) => {
        //         if (temAcesso('CTRLACS-USR-06')) {
        //             next()
        //         }
        //     }
        // }
    ]
}
